import PropTypes from 'prop-types';
import InputField from 'app/components/forms/inputField';

export default class NumberField extends InputField {
  static propTypes = {
    ...InputField.propTypes,
    min: PropTypes.number,
    max: PropTypes.number,
  };

  coerceValue(value, prevValue) {
    let intValue = parseInt(value, 10);

    // return previous value if new value is NaN, otherwise, will get recursive error
    let isNewCoercedNaN = isNaN(intValue);

    if (!isNewCoercedNaN) {
      return intValue;
    }

    return '';
  }

  getType() {
    return 'number';
  }

  getAttributes() {
    return {
      min: this.props.min || undefined,
      max: this.props.max || undefined,
    };
  }
}



// WEBPACK FOOTER //
// ./app/components/forms/numberField.jsx